<div class="copy-hud">

    <div>
        <img [src]="imgSrc" alt="Icon">
        <span>Buchlink kopiert <i class="fa fa-link"></i></span>
    </div>
</div>